import { FC, createContext, ReactNode } from "react";
import { Dispatch, SetStateAction, useContext } from "react";

type TopupRequestPayload = {
  name?: string;
  Page?: number;
  PageSize?: number;
  categoryCode?: string;
};

type TopupListingContextType = {
  filters: TopupRequestPayload;
  setFilters: Dispatch<SetStateAction<TopupRequestPayload>>;
};

const TopupListingContext = createContext<null | TopupListingContextType>(null);

const TopupListingProvider: FC<{ value: TopupListingContextType; children: ReactNode }> = ({ value, children }) => {
  return <TopupListingContext.Provider value={value}>{children}</TopupListingContext.Provider>;
};

const useTopupListing = () => {
  const context = useContext(TopupListingContext);
  if (!context) throw new Error("Illegal Usage of Context outside the TopupListingContext");
  return context;
};


export {TopupListingProvider,useTopupListing};
